let styles = {
  container: {
    textTransform: 'uppercase',
    fontSize: '12px',
    color: '#616161',
    display: 'flex',
    flexDirection: 'row',
  },
  crumb: {
    cursor: 'pointer',
  },
  divider: {
    margin: '0 .5em'
  },
  currentLocation: {}
};

export default styles;
